import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { UpdateDashboardVisibilityValidationSchema } from '../../schemas/dashboards/dashboard.schema';

interface UseUpdateDashboardVisibilityProps {
  dashboardId: string | undefined,
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    UpdateDashboardVisibilityValidationSchema
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useUpdateDashboardVisibility = ({ dashboardId, options }: UseUpdateDashboardVisibilityProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['updateDashboardVisibility', dashboardId],
    mutationFn: (form) => {
      return privateAxios.put(`/dashboards/${dashboardId}/update_visibility`, {
        dashboard: {
          visibility: form.visibility?.value,
        },
      });
    },
    ...options,
  });
}
